<template>
<div>
<h2>Pridelovalec</h2>
KMG MID: {{ pridelovalec.kmgmid?pridelovalec.kmgmid:"Ne obstaja" }}, NOSILEC: {{ pridelovalec.imenosilca }}<br/>
<p v-if="pridelovalec.kmgmid">
{{pridelovalec.naslov}}, {{pridelovalec.postnastevilka}} {{pridelovalec.posta}} 
</p>
<p v-else>
	{{pridelovalec.naslovnosilca}}, {{pridelovalec.postnastevilkanosilca}} {{pridelovalec.postanosilca}} 
</p>
</div>
</template>
<script>



export default {
    props: {
      pridelovalec:Object   },
    
  
  
  created(){
  	console.log(this.pridelovalec);
  }
}
</script>